import React from 'react';
export const GuaranteeSection = () => {
  return <section className="bg-familia-lightBg py-10 md:py-16 px-4 md:px-6" data-id="element-112">
      <div className="max-w-2xl mx-auto w-[92%] md:w-full" data-id="element-113">
        <div className="bg-white border-2 border-familia-gold p-6 md:p-10 rounded-3xl text-center relative overflow-hidden shadow-md" data-id="element-114">
          <div className="text-4xl md:text-5xl mb-4" data-id="element-115">🛡️</div>
          <h2 className="text-[20px] sm:text-2xl md:text-3xl font-display font-extrabold mb-4 uppercase tracking-wider text-familia-bg" data-id="element-116">
            GARANTÍA GOL DE VICTORIA — 7 DÍAS
          </h2>

          <div className="text-familia-darkGray text-[14px] md:text-base leading-relaxed mb-6 max-w-lg mx-auto font-medium" data-id="element-117">
            <p className="mb-3" data-id="element-118">
              Descargá el material, revisá la planificación y explorá las
              primeras actividades.
            </p>
            <p data-id="element-119">
              Si dentro de los primeros 7 días sentís que no es lo que
              esperabas, podés solicitar la devolución del 100% del dinero.
            </p>
          </div>

          <div className="inline-block bg-familia-green text-white font-bold px-5 py-2.5 rounded-full text-xs md:text-sm shadow-sm" data-id="element-120">
            Comprás con 7 días de protección.
          </div>
        </div>
      </div>
    </section>;
};